<template>

    <div v-if="ipc">
        <h2>Manage files</h2>

        <h3>Upload new file</h3>

        <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">
            <form @submit.prevent="handleSubmit(upload)">
                <ValidationProvider tag="div" class="form-group" name="type" rules="required" v-slot="{ errors }" v-if="typeOptions">
                    <label>* Type</label>
                    <v-select v-model="attachment.type"
                              :options="selectableTypes"
                              label="label"
                              :reduce="type => type.id"
                              :clearable="false"
                              :searchable="false">
                    </v-select>
                    <div class="form-text text-danger">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider tag="div" class="form-group" name="name" v-slot="{ errors }">
                    <label for="name">Name</label>
                    <input id="name" type="text" class="form-control" v-model="attachment.name">
                    <div class="form-text text-danger">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider tag="div" ref="fileValProvider" class="form-group" name="file" rules="required" v-if="showFileInput" v-slot="{ validate, errors }">
                    <label for="file">* File</label>
                    <input id="file" type="file" class="form-control" ref="fileInput" @change="validate">
                    <div class="form-text text-danger">{{ errors[0] }}</div>
                </ValidationProvider>

                <div class="form-group mb-0">
                    <button type="submit" class="btn btn-primary btn-block">
                        Upload attachment
                    </button>
                </div>
            </form>
        </ValidationObserver>

        <h3 class="mt-4">Uploaded files</h3>

        <table class="table table-bordered table-layout-fixed">
            <colgroup>
                <col style="width: 150px;">
                <col />
                <col style="width: 150px;">
            </colgroup>
            <thead>
            <tr>
                <th>Type</th>
                <th>Name</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="attachment in ipc.attachments">
                <td><strong>{{ typeOptions.find(t => t.id === attachment.type).label }}</strong></td>
                <td>{{ attachment.name }}</td>
                <td>
                    <button class="btn btn-sm btn-danger btn-icon" @click="deleteAttachment(attachment)">
                        <inline-svg src="/assets/icons/trash.svg" />
                    </button>
                </td>
            </tr>
            </tbody>
        </table>

    </div>

</template>

<script>
import StatisticsService from '../../../js/services/StatisticsService';
import LegalService from '../../../js/services/LegalService';

export default {
    data() {
        return {
            ipc: null,
            typeOptions: null,
            attachment: {},
            showFileInput: true,
        };
    },
    computed: {
        ipcId() {
            return this.$route.params.id;
        },
        selectableTypes() {
            const singles = ['application', 'first_registration', 'priority', 'last_renewal'];
            const selectables = [];

            for (const type of this.typeOptions) {
                if (singles.includes(type.id)) {
                    if (! this.ipc.attachments.find(a => a.type === type.id)) {
                        selectables.push(type);
                    }
                } else {
                    selectables.push(type);
                }
            }

            return selectables;
        },
    },
    watch: {
        async ipcId() {
            await this.loadIpc();
        },
    },
    async mounted() {
        this.typeOptions = (await LegalService.getLegalMeta()).attachment_types;
        await this.loadIpc();
    },
    methods: {
        async loadIpc() {
            this.ipc = await StatisticsService.getIPC(this.ipcId);
        },
        async upload() {
            try {
                const formData = new FormData();

                formData.append('attachments[0][type]', this.attachment.type);
                formData.append('attachments[0][file]', this.$refs.fileInput.files[0]);

                if (this.attachment.name) {
                    formData.append('attachments[0][name]', this.attachment.name);
                }

                this.ipc = await StatisticsService.uploadIpcAttachment(this.ipcId, formData);

                this.attachment = {};

                // Workaround to reset the validation state of the file input
                this.$refs.fileInput.value = null;
                this.showFileInput = false;
                await this.$nextTick();
                this.showFileInput = true;
                this.$refs.fileValProvider.reset();
            } catch (e) {
                this.displayFormErrorsOrThrow(e);
            }
        },
        async deleteAttachment(attachment) {
            await StatisticsService.deleteIpcAttachment(attachment.id);

            this.ipc.attachments.splice(
                this.ipc.attachments.indexOf(attachment),
                1
            );
        },
    },
};
</script>
